import React from 'react';

import Viewer from '../components/viewer';
import { CustomFormParts, Themes } from '../utils/types';
import GenericHotspot from '../components/hotspots/generic-hotspot';
import { HotspotTypes, posterExtraButton } from '../utils/types';
import { videoEmbedGenerator, galleryGenerator, posterGenerator, customFormGenerator } from '../utils/hotspot-data-generators';

export default function Home(props) {
  return (
    <Viewer theme={Themes.Pentland} >

      <GenericHotspot
        yaw={1.1359918660347655}
        pitch={0.07580395810538668}
        title="Welcome"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/panel1.png',
          extraWide: true,
        })}
      />

      <GenericHotspot
        yaw={1.4288622177225956}
        pitch={0.08580395810538668}
        title="The Pentland Floating Offshore Wind Farm"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/panel2.png',
          extraWide: true,
        })}
      />

      <GenericHotspot
        yaw={1.7481287446997986}
        pitch={0.12580894719960448}
        title="Onshore proposal"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/panel3.png',
          extraWide: true,
        })}
      />

      <GenericHotspot
        yaw={2.0381287446997986}
        pitch={0.08980894719960448}
        title="Consents and Assessments"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/panel4.png',
          extraWide: true,
        })}
      />

      <GenericHotspot
        yaw={2.596216446174799}
        pitch={0.07696019204613131}
        title="LVIA - Substation Option 1"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/panel5.png',
          extraWide: true,
          pdfLink: 'pdfs/panel5-extended.pdf',
          linkText: 'View how the substation (option 1) may look in more detail (PDF)'
        })}
      />

      <GenericHotspot
        yaw={2.836216446174799}
        pitch={0.08096019204613131}
        title="LVIA - Substation Option 2"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/panel6.png',
          extraWide: true,
          pdfLink: 'pdfs/panel6-extended.pdf',
          linkText: 'View how the substation (option 2) may look in more detail (PDF)'
        })}
      />

      <GenericHotspot
        yaw={3.116216446174799}
        pitch={0.08096019204613131}
        title="Benefits to the Community"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/panel7.png',
          extraWide: true,
        })}
      />

      <GenericHotspot
        yaw={3.412216446174799}
        pitch={0.07696019204613131}
        title="Indicative Development Timeline"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/panel8.png',
          extraWide: true,
        })}
      />

      <GenericHotspot
        yaw={3.662216446174799}
        pitch={0.07396019204613131}
        title="Frequently Asked Questions"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/panel9.png',
          extraWide: true,
        })}
      />

      <GenericHotspot
        yaw={-0.019769703281273365}
        pitch={-0.02627856372395776}
        title="More info"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/whiteboard.png',
          zoomPan: false,
        })}
      />

      <GenericHotspot
        yaw={0.006927245950757452}
        pitch={0.28389376705612705}
        title="Contact us / Feedback"
        type={HotspotTypes.CustomForm}
        data={customFormGenerator({
          title: "Contact us / Feedback",
          action: 'https://submit-form.com/7szjzKkL',
          method: 'POST',
          partsConfig: [
            CustomFormParts.para('The feedback received from this consultation is taken into consideration during the development of the project. We need your feedback in order to understand what is important to you, understand your concerns and ensure that your views and suggestions are heard so that this proposal brings benefits to the local community as well as the wider public.'),
            CustomFormParts.para(<>Please note that this consultation specifically relates to the onshore elements of the proposal, including the substation and onshore export cables. The offshore elements of the Pentland Floating Offshore Wind Farm have been subject to a different planning application process through Marine Scotland. We are not able to take any further feedback on the offshore elements at this stage. There will be an opportunity to provide comments to Marine Scotland on the offshore elements of the project and this will be advertised on the Pentland Floating Offshore Wind Farm website: <a href="https://www.pentlandfloatingwind.com">pentlandfloatingwind.com</a>.</>),
            CustomFormParts.para('We will review the comments received together with the results of the environmental assessments to be undertaken to inform the final design of the project. Details of how your comments may have influenced the final design will be explained in the application submissions.'),
            CustomFormParts.para('Please note that any comments made on the proposals at this stage are not representations to the planning authority. If a planning application is subsequently submitted to The Highland Council, normal neighbour notification and publicity will be undertaken at that time and you will have an opportunity then to make formal representations to the Council.'),

            CustomFormParts.radioChoice('Did you find the exhibition accessible and easy to navigate?', 'Did you find the exhibition accessible and easy to navigate?', ['Yes', 'No'], true),
            CustomFormParts.textarea('Accessibility - If no, what could we do better?', 'If no, what could we do better?'),

            CustomFormParts.radioChoice('Do you have any concerns with the proposed location of the onshore infrastructure for the Pentland Floating Offshore Wind Farm?', 'Do you have any concerns with the proposed location of the onshore infrastructure for the Pentland Floating Offshore Wind Farm?', ['None', 'Concerned about the location', 'Unsure'], true),
            CustomFormParts.textarea('Proposed location for PFOWF - Could you please provide more information?', 'Could you please provide more information?'),

            CustomFormParts.radioChoice('Do you have any concerns with the elements of the proposed onshore infrastructure for the Pentland Floating Offshore Wind Farm?', 'Do you have any concerns with the elements of the proposed onshore infrastructure for the Pentland Floating Offshore Wind Farm?', ['None', 'Concerned about the elements', 'Unsure'], true),
            CustomFormParts.textarea('Proposed offshore elements for PFOWF - Could you please provide more information?', 'Could you please provide more information?'),

            CustomFormParts.radioChoice('Do you have any concerns on the level of engagement undertaken to date from Highland Wind Limited?', 'Do you have any concerns on the level of engagement undertaken to date from Highland Wind Limited?', ['Not enough', 'Correct level', 'Unsure'], true),

            CustomFormParts.input('Would you like to be kept informed of project updates? If so, please confirm your e-mail address', 'email', 'Would you like to be kept informed of project updates? If so, please confirm your e-mail address'),

            CustomFormParts.textarea('Do you have any specific concerns regarding the onshore proposal you would like the project team to consider?', "Do you have any specific concerns regarding the onshore proposal you would like the project team to consider?"),

            CustomFormParts.para('Contact Us'),
            CustomFormParts.para(<>If you have any additional comments, feedback or would like to get in touch with the project team then please email us at <a href="mailto:pentland-stakeholder@cop.dk">pentland-stakeholder@cop.dk</a>. Alternative methods to contact us are listed on our website at <a href="www.pentlandfloatingwind.com">www.pentlandfloatingwind.com</a>.
              Please do not disclose sensitive personal data (race, ethnicity, health information, religion, sexuality or sex life, political opinion, philosophical belief, and trade union membership) or other confidential information such as national identification number or information related to criminal offences or convictions.</>),
            CustomFormParts.para(<><span style={{ fontSize: '16px' }} >Information is collected and stored in accordance with Highland Wind Limited's <a href="https://www.pentlandfloatingwind.com/privacy-policy">Privacy Policy</a>.</span></>),
          ],
        })}
      />

      <GenericHotspot
        yaw={-0.69703057718441542}
        pitch={0.096777147547136337}
        title="Meet the Team"
        type={HotspotTypes.Gallery}
        data={galleryGenerator({
          modalStyle: { width: 'calc(60vh * (800/1000) + 20px)', padding: '10px' },
          images: [
            'images/team/alan-hannah.jpg',
            'images/team/richard-copeland.jpg',
            'images/team/andy-blyth.jpg',
            'images/team/amy-townsend.jpg',
            'images/team/lee-senoussi.jpg',
            'images/team/isaac-connell.jpg',
            'images/team/rebecca-marshall.jpg',
            'images/team/hugh-morgan.jpg',
            'images/team/tamsin-watt.jpg',
            'images/team/shelley-kay.jpg',
            'images/team/peter-moore.jpg',
          ],
          markdownCaptions: [
            <>
              <p>
                <b>Alan Hannah</b> <br />
                My name is Alan Hannah and I am the Managing Director for Copenhagen Offshore Partners (COP) in the UK. I have been involved in offshore wind projects spanning over an 18-year period with significant experience in the development, construction, and operations of offshore wind farms across Europe and U.S. I lead COP’s Floating Offshore Wind Competence Centre in Edinburgh.
              </p>
            </>,
            <>
              <p>
                <b>Richard Copeland</b> <br />
                My name is Richard Copeland, and I am the Project Director of the Pentland Floating Offshore Wind Farm. My role is to lead the Project Team and oversee the delivery of the Project.
              </p>
            </>,
            <>
              <p>
                <b>Andy Blyth</b> <br />
                My name is Andy Blyth and I provide consents support for the Pentland Floating Offshore Wind Farm. My role is to support the consenting activities for the project to deliver a project that minimises environmental impacts. In my role I provide technical support to the preparation of the Environmental Impact Assessment Reports.
              </p>
            </>,
            <>
              <p>
                <b>Amy Townsend</b> <br />
                My name is Amy Townsend and I provide Onshore Consents Support for the Pentland Floating Offshore Wind Farm. My role is to support the consents team by providing Planning and EIA advice for the onshore elements of the project.
              </p>
            </>,
            <>
              <p>
                <b>Lee Senoussi</b> <br />
                My name is Lee Senoussi and I am the Engineering Manager for the Pentland Floating Offshore Wind Farm. My role is to oversee the engineering and design of the wind farm.
              </p>
            </>,
            <>
              <p>
                <b>Isaac Connell</b> <br />
                My name is Isaac Connell and I am the Deputy EPC Director for the Pentland Floating Offshore Wind Farm. My role is to support the EPC director and package managers in the coordination of engineering and procurement activities across all project contracts.
              </p>
            </>,
            <>
              <p>
                <b>Rebecca Marshall</b> <br />
                My name is Rebecca Marshall and I am the Consents Coordinator on the Pentland Floating Offshore Wind Farm. My role is to support the Consents Manager with permitting activities for the project. I have been in contact with a number of people in the local community and I look forward to continue working with you through the development of the project.
              </p>
            </>,
            <>
              <p>
                <b>Hugh Morgan</b> <br />
                My name is Hugh Morgan and I am the Onshore Package Manager. My role is to manage the onshore electrical works and substation.
              </p>
            </>,
            <>
              <p>
                <b>Tamsin Watt</b> <br />
                My name is Tamsin Watt and I am the Offshore Consents Manager for the Pentland Floating Offshore Wind Farm. My role is to oversee the preparation and submission of the Offshore Environmental Impact Assessment Report for the Project which will be submitted in support of the consent application. I also support offshore consenting activities across the Project including stakeholder engagement activities and the preparation of other licence or consent applications that may be required.
              </p>
            </>,
            <>
              <p>
                <b>Shelley Kay</b> <br />
                Hi, my name is Shelley Kay and I'm the Senior Project Management Office (PMO) Manager for the Pentland Floating Offshore Wind Farm Project. I support the team with project planning, risk, cost and documentation management activities.
              </p>
            </>,
            <>
              <p>
                <b>Peter Moore</b> <br />
                My name is Peter Moore and I am the Consents Lead for the Pentland Floating Offshore Wind Farm. My role is to manage the applications for the project to obtain the necessary permits and licences to build and operate the wind farm. This includes managing the project's Environmental Impact Assessment and engaging with stakeholders such as regulators, nature conservation bodies, fishermen and any other individuals with a potential interest in the project.
              </p>
            </>,
          ],
        })}
      />

    </Viewer>
  );
}